import environment from 'environment';

export default environment;